<div class="container">
    <h1>TORNO Y FRESA</h1>

   
    <div style="text-align: center;"> <img src="assets/imagenes/torno1.jpg" width="480" height="360"><img
            src="assets/imagenes/torno2.jpg" width="480" height="360">
    </div>
</div>